import { useState } from 'react';
import Switch from 'components/common/Switch/Switch';

/**
 * Examples of Switch component.
 */

function SwitchExamplePage(): JSX.Element {
  const [value, setValue] = useState(true);

  return (
    <section id="switch" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Switch</h1>
      <div className="ExamplesPage__Description">Used to provide on/off or toggle functionality.</div>
      <div className="ExamplesPage__ExampleRow">
        <Switch label="Click to toggle this switch" checked={value} onChange={setValue} />
      </div>
    </section>
  );
}

export default SwitchExamplePage;
